import type { TextShortcut } from "../../types.ts";
import { canDeleteShortcut } from "../Shortcuts.helpers.ts";
import { ShortcutCard } from "./ShortcutCard.tsx";

type ShortcutListProps = {
  shortcuts: TextShortcut[];
  activeShortcutId: string;
  loading: boolean;
  query: string;
  role: string;
  canInsert: boolean;
  onQueryChange: (query: string) => void;
  onEdit: (shortcut: TextShortcut) => void;
  onDelete: (shortcut: TextShortcut) => void;
  onInsert: (shortcut: TextShortcut) => void;
  onCopy: (shortcut: TextShortcut) => void;
};

export function ShortcutList({
  shortcuts,
  activeShortcutId,
  loading,
  query,
  role,
  canInsert,
  onQueryChange,
  onEdit,
  onDelete,
  onInsert,
  onCopy,
}: ShortcutListProps) {
  return (
    <aside className="shortcuts-list-panel" aria-label="Biblioteca de atalhos">
      <div className="shortcuts-search">
        <input
          className="field"
          placeholder="Buscar por gatilho, titulo ou texto..."
          value={query}
          onChange={(event) => onQueryChange(event.currentTarget.value)}
        />
      </div>
      <div className="shortcuts-list">
        {loading ? <div className="shortcuts-empty">Carregando atalhos...</div> : null}
        {!loading && !shortcuts.length ? <div className="shortcuts-empty">Nenhum atalho encontrado.</div> : null}
        {shortcuts.map((shortcut) => (
          <ShortcutCard
            key={shortcut.id}
            shortcut={shortcut}
            active={activeShortcutId === String(shortcut.id)}
            canDelete={canDeleteShortcut(shortcut, role)}
            canInsert={canInsert}
            onEdit={() => onEdit(shortcut)}
            onDelete={() => onDelete(shortcut)}
            onInsert={() => onInsert(shortcut)}
            onCopy={() => onCopy(shortcut)}
          />
        ))}
      </div>
    </aside>
  );
}
